var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import classNames from 'classnames';
import { getSortIcon, getSortType } from '../utils';
import Resizer from '../../resizer/components/Resizer';
import { useDrag, useDrop } from 'react-dnd';
import { COLUMN_HEADER_DRAG_TYPE } from './ColumnDragLayer';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { COLUMN_MINIMUM_PIXEL_WIDTH } from '../constants';
import AccurityIcon from '../../icon/components/AccurityIcon';
var columnBeingResized;
var canDrag = function () {
    return columnBeingResized === undefined;
};
var beginDrag = function (monitor, props) {
    // A magic number for calculating the width of dragged header based on number of characters
    var calculatedWidth = props.label.length * 8 + 80 + Math.round(150 / props.label.length);
    return __assign(__assign({}, monitor.getItem()), { type: COLUMN_HEADER_DRAG_TYPE, index: props.index, label: props.label, width: calculatedWidth });
};
var collectDragProps = function (monitor) {
    return {
        isDragging: monitor.isDragging(),
    };
};
var onDrop = function (item, monitor, props) {
    var dragIndex = monitor.getItem().index;
    var hoverIndex = props.index;
    if (props.columnDropAction && dragIndex !== hoverIndex) {
        props.columnDropAction(dragIndex, hoverIndex);
    }
};
var HeaderCell = function (props) {
    var name = props.name, label = props.label, sort = props.sort, sortAction = props.sortAction, width = props.width, resizable = props.resizable, draggable = props.draggable, isResizing = props.isResizing, handleResize = props.handleResize, onStartResize = props.onStartResize, onStopResize = props.onStopResize, icon = props.icon, _a = props.sortable, sortable = _a === void 0 ? true : _a;
    var _b = useDrag({
        item: {
            type: COLUMN_HEADER_DRAG_TYPE,
            label: label,
        },
        canDrag: canDrag,
        begin: function (monitor) { return beginDrag(monitor, props); },
        collect: collectDragProps,
    }), dragProps = _b[0], dragRef = _b[1], connectDragPreview = _b[2];
    var _c = useDrop({
        accept: COLUMN_HEADER_DRAG_TYPE,
        drop: function (item, monitor) { return onDrop(item, monitor, props); },
    }), dropRef = _c[1];
    useEffect(function () {
        connectDragPreview(getEmptyImage(), { captureDraggingState: true });
    }, []);
    var dragSource = (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: dragRef, className: 'headerCellDragSource', style: { width: '100%', height: '20px', position: 'absolute', border: 'none', } })));
    return (React.createElement("th", { ref: dropRef, style: { width: width + '%' }, key: name, "data-name": name, className: classNames('accDataTable__headerCell', { dragging: dragProps.isDragging }) },
        React.createElement("div", { className: "cell" },
            React.createElement("div", { onClick: sortable ? function () { return sortAction(name, getSortType(sort)); } : undefined, style: { flex: 1, position: 'relative', width: '100%' }, className: "ellipsis" },
                draggable && !isResizing && dragSource,
                React.createElement("div", { className: "headerCell__label" },
                    React.createElement("div", null, getSortIcon(sort)),
                    React.createElement("div", { className: "ellipsis" },
                        icon ? React.createElement(AccurityIcon, { fontSize: "small", className: "headerCell__icon", iconName: icon }) : null,
                        label))),
            resizable &&
                React.createElement(Resizer, { value: width || 0, onResize: handleResize, min: COLUMN_MINIMUM_PIXEL_WIDTH, onStartResize: onStartResize, onStopResize: onStopResize, displayDefaultResizeHandle: false }))));
};
export default HeaderCell;
//# sourceMappingURL=HeaderCell.js.map